<template>
  <div class="row no-gutters justify-content-between align-items-center">
    <div
      v-for="item in typeList"
      :key="item.valor"
      class="radioBox d-inline-flex align-items-center tipos-registros-anteriores"
      :class="{ 'active': item.valor === tipo_registro, 'radioBoxDisabled': item.disabled, 'radioBoxBlue': propHeaderBlue }"
      @click="onClick(item)">
      <label
        :key="item.id"
        class="radioBox_btn w-100 text-center position-relative"
        :class="{ 'radioBoxDisabled_btn': item.disabled }"
        :for="item.text">
        <svg v-if="item.icon"
             class="radioBox_icon icon--md"
             role="presentation">
          <use :xlink:href="'#' + item.icon.id" />
        </svg>
        <input
          :id="item.text"
          v-model="tipo_registro"
          class="radioBox_input position-absolute"
          :class="{ 'radioBoxDisabled_input': item.disabled }"
          name="typeFilter"
          type="radio"
          :value="item.valor"
          :disabled="item.disabled"
          @change="$emit('input', item.valor)">
        <span class="radioBox_title w-100 d-inline-block">{{ item.text }}</span>
      </label>
    </div>
  </div>
</template>

<script>
  /* icons */
  import icon_casamento from "@/assets/icons/engagement.svg?sprite"
  import icon_nasc from "@/assets/icons/baby-buggy.svg?sprite"
  import icon_obito from "@/assets/icons/flower.svg?sprite"
  import icon_livroe from "@/assets/icons/book-open-variant.svg?sprite"

  export default {
    name: "BoxTipo",
    props: {
      propTipoRegistro: {
        type: [Number, String]
      },
      propOptions: {
        type: Array,
        default: () => ([])
      },
      propHeaderBlue: {
        type: Boolean,
        default: () => false
      },
      propDisabled: {
        type: Boolean,
        default: () => false
      }
    },
    data () {
      return {
        tipo_registro: null,
        typeList: [
          {
            text: "Nascimento",
            id: 1,
            valor: "N",
            icon: icon_nasc,
            disabled: this.propDisabled
          },
          {
            text: "Casamento",
            id: 2,
            valor: "C",
            icon: icon_casamento,
            disabled: this.propDisabled
          },
          /*{
            text: "Óbito",
            id: 3,
            valor: "O",
            icon: icon_obito,
            disabled: false
          },*/
          {
            text: "Livro-E",
            id: 4,
            valor: "L",
            icon: icon_livroe,
            disabled: true
          }
        ]
      }
    },
    mounted () {
      this.tipo_registro = this.propTipoRegistro

      if (this.propOptions.length > 0) {
        this.typeList = [ ...this.propOptions ]
      }
    },
    methods: {
      onClick (item) {
        if (!item.disabled) {
          this.tipo_registro = item.valor
          this.$emit(`input`, this.tipo_registro)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../scss/_utilities/_exports";

  .radioBox {
    border: pxToRem(1) solid $color-gray-light;
    cursor: pointer;
    max-width: pxToRem(100);
    min-height: pxToRem(80);
    transition: background-color 0.15s linear, border-color 0.15s linear;
    width: 33%;

  &_btn {
     cursor: pointer;
   }

  &_input {
     height: 0;
     opacity: 0;
     width: 0;
   }

  &_icon {
     fill: $color-gray-light;
   }

  &_title {
     color: $color-gray-light;
     font-size: pxToRem(14);
     font-weight: 500;
     transition: color 0.15s linear;
   }

  &.active,
  &:hover {
     background-color: $sofiaRei-blue;
     border-color: $sofiaRei-blue;

    .radioBox_icon {
      fill: $color-white;
    }

    .radioBox_title {
      color: $color-white;
    }
  }
  }

  .radioBoxBlue {
    &.active,
    &:hover {
       background-color: $sinoreg-blue !important;
       border-color: $sinoreg-blue !important;

      .radioBox_icon {
        fill: $color-white !important;
      }

      .radioBox_title {
        color: $color-white !important;
      }
    }
  }

  .radioBoxDisabled {
    border: pxToRem(1) solid $color-gray-light;
    background-color: $color-gray;
    max-width: pxToRem(100);
    min-height: pxToRem(80);
    transition: background-color 0.15s linear, border-color 0.15s linear;
    width: 33%;

    &_btn {
      cursor: pointer;
    }

    &_input {
      height: 0;
      opacity: 0;
      width: 0;
    }

    &_icon {
      fill: $color-gray;
    }

    &_title {
      color: $color-gray;
      font-size: pxToRem(14);
      font-weight: 500;
      transition: color 0.15s linear;
    }
    &.active,
     &:hover {
       background-color: $color-gray;
       border-color: $color-gray;
     }
  }
</style>
